module.exports = __webpack_public_path__ + "src/assets/img/page9/9e7f78fe78892f7b458ba4828dc08001.png";